// Get tokens from environment variables
// IMPORTANT: Set these environment variables in your hosting platform
export const PUBLIC_TOKEN = process.env.REACT_APP_SHOPIFY_PUBLIC_TOKEN;
export const URL = process.env.REACT_APP_SHOPIFY_STORE_URL;

// Check if environment variables are set
if (!PUBLIC_TOKEN || !URL) {
  console.error('ERROR: Shopify API credentials are missing!');
  console.error('Please set REACT_APP_SHOPIFY_PUBLIC_TOKEN and REACT_APP_SHOPIFY_STORE_URL environment variables');
} else {
  console.log('Shopify API configuration loaded successfully');
} 